import { useQuery } from '@tanstack/react-query';
import { fetchSenderHealth } from '@/lib/sender-health-api';

/**
 * The reputation trend.
 *
 * A generous `staleTime`: the underlying snapshot is taken once a night at 03:00 UTC, so refetching on
 * every mount would ask the same question repeatedly of data that cannot have changed. An hour is well
 * inside a day and well outside a page visit.
 */
export function useSenderHealth(days: number) {
  return useQuery({
    queryKey: ['sender-health', days] as const,
    queryFn: () => fetchSenderHealth(days),
    staleTime: 60 * 60 * 1000,
  });
}
